import { lazy } from "react";

export const CreateServiceAsync = lazy(() => import("./CreateService"));
